import { render } from "./LegendForm.vue?vue&type=template&id=6a062fae"
import script from "./LegendForm.vue?vue&type=script&lang=js"
export * from "./LegendForm.vue?vue&type=script&lang=js"

import exportComponent from "/root/openmct/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__